import type { Rect, Size } from '@/core/geometry/types'

export enum ExportFormat {
  Jpeg = 'jpeg',
  Png = 'png',
}

export enum ResizeMode {
  Original = 'original',
  InstagramTarget = 'instagram-target',
  Custom = 'custom',
}

export const CUSTOM_SIZE_MIN = 320
export const CUSTOM_SIZE_MAX = 8192

export enum ExportDelivery {
  Files = 'files',
  Archive = 'archive',
}

export enum ExportAction {
  Auto = 'auto',
  Share = 'share',
  SaveFiles = 'save-files',
  SaveArchive = 'save-archive',
}

export enum ShareOutcome {
  Shared = 'shared',
  Cancelled = 'cancelled',
}

export interface ExportOptions {
  format: ExportFormat
  jpegQuality: number
  resizeMode: ResizeMode
  customLongestSide: number | null
}

export interface ExportOutputSpec {
  sourceRect: Rect
  targetSize: Size
  fileNameSuffix: string
}

export interface ExportPlan {
  renderSize: Size
  outputs: ExportOutputSpec[]
  readme?: {
    fileName: string
    contents: string
  }
  warnings?: string[]
}

export interface ExportResult {
  blob: Blob
  fileName: string
  size: Size
}

export interface ExportArchive {
  blob: Blob
  fileName: string
}
